@if ((product?.mapperSaleProducts)[0].productOption?.reviewDetails.ratingAvg > 0) {
  <div
    class="gopicky-plugin-wrapper"
    id="gopicky-product-reviews"
    style="--color-dark: #e04fa3; --color-rating: #e04fa3; --color-light: #d2bf98"
  >
    <div class="">
      <div id="gopicky-product-reviews-section">
        <div class="gopicky-page-width">
          <div class="gopicky-plugin-wrapper" id="gopicky-media-feed">
            <div>
              <div class="gopicky-rating-distribution">
                <div class="gopicky-rating-data">
                  <span class="gopicky-heading">Ratings &amp; Reviews</span
                  ><span class="gopicky-rating">{{
                    (product?.mapperSaleProducts)[0].productOption?.reviewDetails.ratingAvg | number: '1.1-1'
                  }}</span>
                  <ngx-stars
                    [readonly]="true"
                    [size]="1"
                    [maxStars]="5"
                    [initialStars]="(product?.mapperSaleProducts)[0].productOption.reviewDetails.ratingAvg"
                    [color]="'#e04fa3'"
                  >
                  </ngx-stars>
                  <span class="gopicky-ratings-count"
                    >Based on
                    {{
                      (product?.mapperSaleProducts)[0].productOption.reviewDetails.reviewCount | number
                    }}
                    ratings</span
                  >
                </div>
                <div class="gopicky-rating-chart">
                  <span class="gopicky-heading">Rating Distribution</span>
                  <div class="gopicky-chart">
                    <div class="gopicky-chart-item">
                      <span class="gopicky-number">1</span>
                      <div class="gopicky-progress-bar enabled">
                        <div
                          (mouseover)="
                            onMouseoverRating(
                              product.mapperSaleProducts[0].productOption.reviewDetails.ratingDistribution.oneStar
                            )
                          "
                          (mouseout)="onMouseoutRating()"
                          class="gopicky-MuiLinearProgress-bar"
                          [style.transform]="'translateX(-' + oneStar + '%)'"
                        ></div>
                      </div>
                    </div>
                    <div class="gopicky-chart-item">
                      <span class="gopicky-number">2</span>
                      <div class="gopicky-progress-bar enabled">
                        <div
                          (mouseover)="
                            onMouseoverRating(
                              product.mapperSaleProducts[0].productOption.reviewDetails.ratingDistribution.twoStar
                            )
                          "
                          (mouseout)="onMouseoutRating()"
                          class="gopicky-MuiLinearProgress-bar"
                          [style.transform]="'translateX(-' + twoStar + '%)'"
                        ></div>
                      </div>
                    </div>
                    <div class="gopicky-chart-item">
                      <span class="gopicky-number">3</span>
                      <div class="gopicky-progress-bar enabled">
                        <div
                          (mouseover)="
                            onMouseoverRating(
                              product.mapperSaleProducts[0].productOption.reviewDetails.ratingDistribution.threeStar
                            )
                          "
                          (mouseout)="onMouseoutRating()"
                          class="gopicky-MuiLinearProgress-bar"
                          [style.transform]="'translateX(-' + threeStar + '%)'"
                        ></div>
                      </div>
                    </div>
                    <div class="gopicky-chart-item">
                      <span class="gopicky-number">4</span>
                      <div class="gopicky-progress-bar enabled">
                        <div
                          (mouseover)="
                            onMouseoverRating(
                              product.mapperSaleProducts[0].productOption.reviewDetails.ratingDistribution.fourStar
                            )
                          "
                          (mouseout)="onMouseoutRating()"
                          class="gopicky-MuiLinearProgress-bar"
                          [style.transform]="'translateX(-' + fourStar + '%)'"
                        ></div>
                      </div>
                    </div>
                    <div class="gopicky-chart-item">
                      <span class="gopicky-number">5</span>
                      <div class="gopicky-progress-bar enabled">
                        <div
                          (mouseover)="
                            onMouseoverRating(
                              product.mapperSaleProducts[0].productOption.reviewDetails.ratingDistribution.fiveStar
                            )
                          "
                          (mouseout)="onMouseoutRating()"
                          class="gopicky-MuiLinearProgress-bar"
                          [style.transform]="'translateX(-' + fiveStar + '%)'"
                        ></div>
                      </div>
                    </div>
                  </div>
                  @if (changeRating) {
                    <span class="gopicky-ratings-count">{{ changeRating | number }}</span>
                  }
                </div>
              </div>
            </div>
            <section class="gopicky-reviews-body">
              <div id="gopicky-tool-bar" class="gopicky-tools">
                <div data-total="2314">
                  <span class="gopicky-reviews-count"
                    >{{
                      (product?.mapperSaleProducts)[0].productOption.reviewDetails.reviewCount | number
                    }}
                    Reviews</span
                  >
                </div>
              </div>
              @for (review of reviews; track review) {
                <ul class="gopicky-review-list">
                  <div class="gopicky-review-container">
                    <div>
                      <div class="gopicky-review-header">
                        @if (review.author_avatar_url.includes('None')) {
                          <div class="gopicky-review-author-no-profile-picture">
                            <span>{{ review.author_nickname ? review.author_nickname[0].toUpperCase() : 'U' }} </span>
                          </div>
                        }
                        @if (!review.author_avatar_url.includes('None')) {
                          <div class="gopicky-review-author-avatar-holder">
                            <img src="{{ review.author_avatar_url }}" alt="" />
                          </div>
                        }
                        <div class="gopicky-review-details">
                          <div class="gopicky-review-author-details">
                            <span class="gopicky-review-author-username">{{ review.author_nickname }}</span>
                            <div class="gopicky-badges">
                              <div class="gopicky-review-author-skin-type">
                                <span>{{ review.author_skin_type }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="gopicky-review-meta-details">
                            <ngx-stars
                              [readonly]="true"
                              [size]="1"
                              [maxStars]="5"
                              [initialStars]="review.rating"
                              [color]="'#e04fa3'"
                            >
                            </ngx-stars>
                            <small class="gopicky-review-datetime">| {{ review.created_at | amDateFormat: 'L' }}</small>
                          </div>
                        </div>
                      </div>
                      <div class="gopicky-review-content">
                        <div>
                          <div class="gopicky-review-content-good">
                            <div class="gopicky-review-content-good-icon-holder">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                                  fill="#F5F5F5"
                                ></path>
                                <path
                                  class="gopicky-thumbs-up"
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M9.40487 15.7283H7.98308C7.45922 15.7283 7.03467 15.3203 7.03467 14.8179V11.6292C7.03467 11.126 7.45922 10.7189 7.98308 10.7189H9.40487V15.7274V15.7283ZM13.3252 9.80853V7.98618C13.3252 7.23225 12.6879 6.62067 11.9025 6.62067L10.0065 10.7189V15.7283H15.3544C15.8269 15.7332 16.2316 15.403 16.3028 14.9536L16.9566 10.8554C17.0352 10.3589 16.6794 9.89377 16.1613 9.81846C16.1116 9.81101 16.0595 9.8077 16.009 9.80853H13.3243H13.3252Z"
                                ></path>
                              </svg>
                            </div>
                            <div class="gopicky-review-content-good-text-holder">
                              <!-- <app-read-more [text]="review.content_good" maxLength="20"></app-read-more> -->
                            </div>
                          </div>
                          <div class="gopicky-review-content-bad">
                            <div class="gopicky-review-content-bad-icon-holder">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                                  fill="#F5F5F5"
                                ></path>
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M9.40721 8.27586H7.98486C7.46143 8.27586 7.03662 8.68387 7.03662 9.1866V12.3742C7.03662 12.8769 7.46143 13.2849 7.98486 13.2849H9.40721V8.27586Z"
                                  fill="#7E7A74"
                                ></path>
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M13.3266 14.1957V16.0172C13.3266 16.7717 12.6899 17.3833 11.9043 17.3833L10.0078 13.285V8.27588H15.3559C15.8286 8.27093 16.2335 8.60107 16.3041 9.05007L16.9584 13.1484C17.0371 13.6456 16.681 14.1101 16.1628 14.1857C16.1126 14.193 16.0614 14.1962 16.0102 14.1957H13.3266Z"
                                  fill="#7E7A74"
                                ></path>
                              </svg>
                            </div>
                            <div class="gopicky-review-content-bad-text-holder">
                              <!-- <app-read-more [text]="review.content_bad" maxLength="20"></app-read-more> -->
                            </div>
                          </div>
                        </div>
                        <div class="gopicky-review-media">
                          <!-- <button mat-raised-button color="primary" (click)="lightbox.open(0)">Open Lightbox</button> -->
                          <div class="gopicky-review-content-images">
                            @for (image of review.image_urls; track image; let i = $index) {
                              <div class="gopicky-review-image-holder" style="display: block">
                                <img sizes="100vw" [src]="image" (click)="imageOpen(i, review.image_urls)" />
                              </div>
                            }
                          </div>
                          <div class="gopicky-review-content-videos">
                            @for (video of review.video_urls; track video; let i = $index) {
                              <div class="gopicky-review-video-holder" style="display: block">
                                <span (click)="videoOpen(i, review.video_urls)">
                                  <video>
                                    <source [src]="video" />
                                  </video>
                                </span>
                              </div>
                            }
                          </div>
                        </div>
                        <div class="gopicky-upvotes">
                          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 12 12">
                            <g fill="#7E7A74" fill-rule="evenodd">
                              <path
                                d="M1.994 6.57c-.985-1.08-.974-2.8.032-3.867 1.017-1.078 2.666-1.078 3.683 0 .109.115.206.238.291.366.085-.128.182-.251.291-.366 1.017-1.078 2.666-1.078 3.683 0s1.017 2.825 0 3.902c-.633.672-1.83 1.734-3.593 3.187-.221.183-.541.183-.764.001-1.801-1.475-3.01-2.549-3.623-3.222z"
                                transform="translate(-414 -1357) translate(220 1272.5) translate(194 84.5)"
                              ></path>
                            </g></svg
                          ><span>{{ review.upvotes | number }}</span>
                        </div>
                        <div class="gopicky-review-divider"></div>
                      </div>
                    </div>
                  </div>
                </ul>
              }
              @if (pageNumber < totalPage) {
                <button class="button-show-more" [innerHTML]="'BUTTON.SHOW_MORE' | t" (click)="onShowMoreReviews()">
                  SHOW MORE
                </button>
              }
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
}
